import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CalendarItemBriefResponse } from '@seo/types';
import { apiPost } from '@/lib/api';

/**
 * A6 → A3: fires POST /v1/calendar-items/:id/brief which either links an
 * existing brief for the item's target keyword or enqueues a new one.
 * The calendar items query is invalidated on success so the row picks up
 * `brief_id` on the next render.
 */
export function useGenerateBriefForItem(calendarId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (itemId: string): Promise<CalendarItemBriefResponse> =>
      apiPost<CalendarItemBriefResponse>(
        `/v1/calendar-items/${itemId}/brief`,
        {},
        { headers: { 'idempotency-key': crypto.randomUUID() } },
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['calendar-items', calendarId] });
    },
  });
}
